import axios from "axios";
import { ToastMixin } from "@/tools/ToastMixin";
import applyCaseMiddleware from "axios-case-converter";
import checkErrorsApiResponse from "@/tools/checkErrorsApiResponse";
import useAuth from "../composables/useAuth";
import { getModuleApiConfig } from "@/modules/api/config/moduleApiConfig";

const toast = ToastMixin("error");
const hdaApiConfig = getModuleApiConfig("hda");

const authRest = applyCaseMiddleware(
  axios.create({
    baseURL: hdaApiConfig.baseUrl,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-api-key": hdaApiConfig.apiKey,
    },
  })
);

authRest.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 400) {
      globalThis.location.href = globalThis.location.origin;
    }
    if (error.response?.status === 406) {
      const { revokeSession } = useAuth();
      revokeSession();
      globalThis.location.reload();
    }
    if (error.response?.status === 401 || error.response?.status === 403) {
      throw error;
    }

    const errorData = checkErrorsApiResponse(error);

    if (errorData.icon != "success") {
      if (errorData.text) {
        await toast.fire({
          icon: errorData.icon,
          title: errorData.title,
          text: errorData.text,
        });
      } else {
        await toast.fire({
          icon: errorData.icon,
          title: errorData.title,
        });
      }
    }
    throw error;
  }
);

export default authRest;
